import { SharedContent } from './shared-content';

export const InvestmentObjectivesContent = {
  header: 'Now tell us your investing style',
  progressLabelIT: 'Internal transfer progress',
  progressLabelITOpenAccount: SharedContent.progressLabelITOpenAccount,
  accountHatPrefix: SharedContent.accountHatPrefix,
};
